import * as fromContacts from '../actions/contacts.action';
import { Contacts, PendingContacts } from '@usimweb/core/models';
import { MakeEntitie } from '../makeentitie';

export interface ContactsState {
  entities: { [username: string]: Contacts };
  invites: { [pk: number]: PendingContacts };
  pending: { [pk: number]: PendingContacts };
  loaded: boolean;
  loading: boolean;
}

export const initialState: ContactsState = {
  entities: {},
  invites: {},
  pending: {},
  loaded: false,
  loading: false,
};

export function reducer(state = initialState, action: fromContacts.ContactsAction): ContactsState {
  switch (action.type) {
    case fromContacts.LOAD_PROJECT_CONTACTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromContacts.LOAD_PROJECT_CONTACTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromContacts.LOAD_PROJECT_CONTACTS_SUCCESS: {
      const contacts = action.payload;
      const entities = MakeEntitie.contacts(state, contacts);

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromContacts.LOAD_CONTACTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromContacts.LOAD_CONTACTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromContacts.LOAD_CONTACTS_SUCCESS: {
      const contacts = action.payload;
      const entities = MakeEntitie.contacts(state, contacts);

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    // anfrage die an mich gehen
    case fromContacts.LOAD_REQUESTS_SUCCESS: {
      const contacts = action.payload;
      const invites = MakeEntitie.invite(state, contacts);

      return {
        ...state,
        loading: false,
        loaded: true,
        invites,
      };
    }

    case fromContacts.DELETE_CONTACTS_SUCCESS: {
      const pk = action.payload;
      const { [pk]: removed, ...entities } = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false,
      };
    }

    // anfragen die ich verschickt habe
    case fromContacts.LOAD_PENDING_REQUESTS_SUCCESS: {
      const contacts = action.payload;
      const pending = MakeEntitie.pending(state, contacts);

      return {
        ...state,
        pending,
      };
    }

    // do nothing if invite contact
    case fromContacts.CREATE_REQUEST_SUCCESS: {
      // const contacts = action.payload;
      // const entities = {
      //   ...state.entities,
      //   [contacts.pk]: contacts,
      // };

      // return {
      //   ...state,
      //   entities,
      // };

      return state;
    }
  }

  return state;
}

export const getContactsEntities = (state: ContactsState) => state.entities;
export const getContactsLoading = (state: ContactsState) => state.loading;
export const getContactstLoaded = (state: ContactsState) => state.loaded;
export const getPendingContacts = (state: ContactsState) => state.pending;
export const getInvites = (state: ContactsState) => state.invites;
